"use client";

import * as stylex from "@stylexjs/stylex";
import { CloudSun } from "lucide-react";
import { copy } from "@/copy";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
import { PlaceForm, type PlaceFormProps } from "./PlaceForm";
import { WeatherBlock } from "./WeatherBlock";
type WeatherSetupProps = Omit<PlaceFormProps, "submitLabel" | "xstyle">;
export function WeatherSetup(props: WeatherSetupProps) {
  return <WeatherBlock>
      <Icon icon={CloudSun} size={64} strokeWidth={1.25} />
      <div className="x78zum5 xdt5ytf x1v2ro7d">
        <Eyebrow>{copy.weather.setup.eyebrow}</Eyebrow>
        <div className="x4c74qz x43273g xh92tn4 x1f41ap9">{copy.weather.setup.title}</div>
        <span className="xosj86m x15i68ds xfrs9s4 x1fzhlzt">{copy.weather.setup.body}</span>
      </div>
      <PlaceForm {...props} submitLabel={copy.weather.setup.submit} />
    </WeatherBlock>;
}